import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivityListItem, ActivityState, Member, MembersState, Organization, OrganizationState } from '@app/_store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SupportIconComponent } from '../../navigation/support-icon/support-icon.component';
import { AccountComponent } from '../../navigation/account/account.component';

@Component({
  selector: 'app-organization-navigation',
  templateUrl: './organization-navigation.component.html',
  styleUrls: ['./organization-navigation.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, RouterLink, RouterLinkActive, SupportIconComponent, AccountComponent, AsyncPipe],
})
export class OrganizationNavigationComponent {
  organization$: Observable<Organization> = inject(Store).select(OrganizationState.current);

  members$: Observable<Member[]> = inject(Store).select(MembersState.getMembers);

  currentActivities$: Observable<ActivityListItem[]> = inject(Store).select(ActivityState.currentActivities);
}
